// React Query hook for the user's Polar plan + a derived
// `isSubscriber` flag. Used by the BuildDeck form to gate the
// Sonnet/Opus toggle and any other subscriber-only affordances.
//
// 5-minute stale time — plan state only changes via webhook so it's
// fine to read a cached copy. Refetches on window focus so a checkout
// that completes in another tab is reflected when the user comes back.

import { useQuery } from "@tanstack/react-query";
import { getMyPlan, type UserPlan } from "./api";

export const PLAN_QUERY_KEY = ["billing-plan"] as const;

export function useSubscription(): {
  plan: UserPlan | null;
  isSubscriber: boolean;
  isLoading: boolean;
} {
  const q = useQuery({
    queryKey: PLAN_QUERY_KEY,
    queryFn: getMyPlan,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: true,
    retry: 1,
  });
  return {
    plan: q.data ?? null,
    isSubscriber: q.data?.is_subscriber ?? false,
    isLoading: q.isLoading,
  };
}
